<template>
  <v-app>
    <!-- Layout component -->
    <component :is="layout">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </component>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",

  data: () => ({
    //
  }),
  computed: {
    ...mapState({
      toast: store => store.toast
    }),
    layout() {
      return this.$route.meta.layout || "default-layout";
    }
  },
  watch: {
    toast(val) {
      if (val && val.show) {
        if (val.type === "error") {
          this.$toast.error(val.message);
        } else {
          this.$toast.success(val.message);
        }
      }
    }
  }
};
</script>

<style scoped>
/**
 * Transition animation between pages
 */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
